import "@valibot/i18n/fr";
import * as valibot from "valibot";

valibot.setGlobalConfig({ lang: "fr" });

export const v = valibot;

export const coerceDate = (input: string | Date) => {
  if (input instanceof Date) return input;
  const parsed = new Date(input);
  if (isNaN(parsed.getTime())) {
    throw new Error("Invalid date string");
  }
  return parsed;
};
